import React, { useMemo } from 'react';

// helpers
import useTranslation from 'hooks/useTranslation';
import { FormSelectProps, SelectOption } from '@ui';
import { TotalTransactionsPerMonthOptions } from 'enums/onboarding/crm';

// components
import { FormSelect } from '@ui';

export type IProps = FormSelectProps;

const TotalTransactionsPerMonthSelect = (props: IProps) => {
  const { t } = useTranslation('onboarding');

  const options = useMemo<SelectOption[]>(
    () =>
      Object.values(TotalTransactionsPerMonthOptions).map((key) => ({
        id: key,
        label: t(`intake_form.total_transactions_per_month_options.${key}`),
      })),
    [t],
  );

  return <FormSelect {...props} options={options} />;
};

export default TotalTransactionsPerMonthSelect;
